<template>
  <div class="slider-element-wrapper">
    <h4
      v-if="Data.title"
      class="slider-element-title"
    >
      {{ Data.title }}
    </h4>

    <div class="slider-element">
      <div
        title="Last Week"
        class="slider-element__arrow slider-element__arrow--previous"
        @click="ArrowClickPrevious"
      >
        <font-awesome-icon :icon="['fas', 'chevron-left']" />
      </div>

      <div
        ref="elementsWrapper"
        class="slider-element__elements-wrapper"
      >
        <div
          ref="elements"
          class="slider-element__elements"
          :style="{ transform: 'translateX('+ElementsTranslateX+'px)' }"
        >
          <slot />
        </div>
      </div>

      <div
        title="Next Week"
        class="slider-element__arrow slider-element__arrow--next"
        @click="ArrowClickNext"
      >
        <font-awesome-icon :icon="['fas', 'chevron-right']" />
      </div>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'SliderElement',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    Data: {
      type: Object,
      default: function() {
        return{
          title: null,
          emitFunctionNamed: 'sliderPosition'
        }
      }
    }
  },
  data() {
    return{
      ElCount: 0,
      ElementsTranslateX: 0,
      ElementPosition: 0
    }
  },
  watch: {
    ElementPosition(position) {
      this.Data.elementPosition = position
      if(this.Data.emitFunctionNamed !== undefined) {
        this.$emit(this.Data.emitFunctionNamed, position)
      }

      let elOffset = this.$refs.elements.children[position].offsetLeft
      const el = this.$refs.elements.children[position]
      const style = window.getComputedStyle ? getComputedStyle(el, null) : el.currentStyle
      const elementsWidth = this.$refs.elements.clientWidth
      const elementsWrapperWidth = this.$refs.elementsWrapper.clientWidth
      const max = elementsWidth - elementsWrapperWidth

      if(elOffset > max) {
        elOffset = max
      }

      if(elOffset !== undefined) {
        this.ElementsTranslateX = -elOffset + ((position === 0) ? (parseFloat(style.marginLeft)) : (parseFloat(style.marginLeft) * 2))
      }
    }
  },
  mounted(Data) {
    this.ElCount = this.$refs.elements.children.length
  },
  methods: {
    ArrowClickPrevious() {
      if(this.ElementPosition > 0) {
        this.ElementPosition -= 1
      } else {
        this.ElementPosition = 0
      }
    },
    ArrowClickNext() {
      if(this.ElementPosition < this.$refs.elements.children.length - 1) {
        this.ElementPosition += 1
      } else {
        this.ElementPosition = 0
      }
    }
  }
}
</script>

<style lang="scss">
  .slider-element-wrapper {
    overflow: hidden;
    width: 100%;
  }
  .slider-element-title {
    margin-top: 0;
    margin-bottom: 0px;
    font-size: 14px;
    font-family: 'Montserrat-SemiBold';
    font-weight: normal;
  }
  .slider-element {
    display: flex;
    align-items: stretch;
    overflow: hidden;
    width: 100%;

    &--no-stretch {
      display: inline-flex;
      flex-direction: column;
      width: auto;
    }

    &__elements-wrapper {
      width: 100%;
      background-color: darken($color-white, 5);
      border-top: 1px solid $color-grey-dark;
      border-bottom: 1px solid $color-grey-dark;
      overflow: hidden;

      .slider-element--no-stretch & {
        width: auto;
      }
      .slider-element--no-borders & {
        border: 0;
      }
      .slider-element--no-background & {
        background: transparent;
      }
    }
    &__elements {
      @include hardware-accelerate(false);
      width: auto;
      min-width: 100%;
      display: inline-block;
      white-space: nowrap;
      transition: transform 0.4s;
      &__element {
        display: inline-block;
        box-sizing: border-box;
        width: 110px;
        padding: 10px;
        text-align: center;
        font-family: $font-primary-semibold;
        color: $color-grey-dark;
      }
    }
    &__arrow {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 45px;
      font-size: 10px;
      border: 1px solid $color-grey-dark;
      color: $color-white;
      cursor: pointer;

      &:before {
        content: '';
        position: absolute;
        height: 30px;
        width: 30px;
        background: rgba(darken($color-white, 30), 0.5);
        transition: 0.6s all;
        z-index: -1;
        border-radius: 50%;
      }

      .svg-inline--fa {
        height: 20px;
        width: 20px;
      }

      .slider-element--no-stretch & {
        width: 35px;
      }

      &--previous {
        border-top-left-radius: $application-base-border-radius;
        border-bottom-left-radius: $application-base-border-radius;
        z-index: $z-normal;
        border-right: 0;
        box-shadow: 3px 0 5px -5px $color-black;
      }
      &--next {
        border-top-right-radius: $application-base-border-radius;
        border-bottom-right-radius: $application-base-border-radius;
        z-index: $z-normal;
        border-left: 0;
        box-shadow: -3px 0 5px -5px $color-black;
      }

      .slider-element--no-borders & {
        border: 0;
      }
      .slider-element--no-background & {
        background: transparent;
      }
    }
  }
</style>
